import {
    FaGithub,
    FaLinkedin,
    FaTwitter,
    FaDev,
    FaArrowUp,
  } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
  return (
    <footer className='w-full text-center text-gray-300 bg-[#0a192f] md:pt-10 dark:bg-gray-300 dark:text-gray-800'>
        <div className='border-t-2 border-gray-300 dark:border-gray-500 border-solid'></div>
        <div className='p-4'>
            <div className='mx-auto grid max-w-7xl grid-cols-2 gap-6 space-y-4 md:mx-2 md:grid-cols-2 '>
                <div className='mx-auto'>
                    <h5 className='mt-4 text-lg font-semibold'>
                       Quick Links
                    </h5>
                    <p>
                        <HashLink className="cursor-pointer" to='/#skills'>
                            Skills
                        </HashLink>
                    </p>
                    <p>
                        <HashLink className="cursor-pointer" to='/#about'>
                            About
                        </HashLink>
                    </p>
                    <p>
                        <HashLink className="cursor-pointer" to='/#projects'>
                            Projects
                        </HashLink>
                    </p>
                    <p>
                        <a href= 'Shivam-Resume.pdf' target='_blank'>Download Resume</a>
                    </p>
                </div>

                <div className='mx-auto'>
                <h5 className='mb-1 text-lg font-semibold'>
                    Connect
                </h5>
                    <div className='flex gap-1.5 mt-2'>
                      <a href="https://www.linkedin.com/in/shivam-webdev">
                          <FaLinkedin className='text-blue-500' size={24} />
                      </a>
                      <a href="https://github.com/Shivamk99">
                          <FaGithub size={24} className='text-white dark:text-gray-800' />
                      </a>
                      <a href="https://twitter.com/Shivamk_99">
                          <FaTwitter size={24} className='text-blue-500' />
                      </a>
                      <a href="https://dev.to/smileyshivam">
                          <FaDev size={24} className='text-red-300' />
                      </a>
                    </div>
                </div>
            </div>
            <p className='text-lg font-medium tracing-wider my-5'>Built with <span class="text-red-700 text-2xl">🧡</span> by Shivam Kumar.</p>
            <Link to="/" className="flex justify-center">
                <button className='text-gray-100 border-2 rounded-lg hover:text-gray-800 hover:bg-gray-100 hover:border-gray-200 px-4 py-2 md:my-2 dark:text-gray-900 dark:border-gray-500 dark:hover:bg-gray-300 dark:hover:border-gray-800' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                Back to Top <FaArrowUp className='inline'/></button>
            </Link>
        </div>
    <p className='p-2 '>
    Copyright &copy; {new Date().getFullYear()}. All right reserved.
    </p>
  </footer>
  )
}

export default Footer